import React from 'react';
import ReactPlayer from 'react-player/lazy';

const Offer = ({ offer }) => {
    const isImage = offer.endsWith('.jpg') || offer.endsWith('.jpeg') || offer.endsWith('.png')|| offer.endsWith('.webp');
    const isVideo = offer.endsWith('.mp4') || offer.endsWith('.webm') || offer.endsWith('.ogg');

    if (isImage) {
        return (
            <div>
                <img src={offer} style={{ width: "100vw", height: "100vh", objectFit: "cover" }} />
            </div>
        );
    } else if (isVideo) {
        return (
            <div>
                <ReactPlayer
          width="100vw"
          height="100vh"
          playsinline={true}
          className="profile-img"
          playing={true}
          autoPlay
          loop={true}
          controls={false}
          muted={true}
          url={offer}
        />
            </div>
        );
    } else {
        return (
            <div>
                Unsupported content type.
            </div>
        );
    }
}

export default Offer;
